import React, {useEffect, useState} from "react";
import Styles from './styles.module.scss';
import Logo from "../_UI/logo";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import settingsIcon from '../../theme/assets/svg/tc_nav_settings_icon.svg';
import logOutIcon from '../../theme/assets/svg/tc_log_out_icon.svg';
import capsuleIcon from '../../theme/assets/svg/tc_nav_capsule_icon.svg';
// import fmeIcon from '../../theme/assets/svg/tc_nav_fme_icon.svg';
import apostolIcon from '../../theme/assets/svg/tc_nav_apostol_icon.svg';
import homeIcon from '../../theme/assets/svg/tc_nav_home_icon.svg';
import avatarIcon from '../../theme/assets/svg/tc_nav_avatar_icon.svg';
import {useDispatch, useSelector} from "react-redux";
import {logout} from "../../store/cabinet/action";
import {isCapsuleSealed} from "../../helpers/capsule";
import LangSwitcher from "../_UI/langSwitcher";



const CabinetHeader = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isMobileNav, setIsMobileNav] = useState(false);
    const [isAvatarHint, setIsAvatarHint] = useState(false);

    const logoutStatusStarted = useSelector(store => store.cabinet.logoutStatusStarted);
    const userData = useSelector(store => store.cabinet.userData);

    // Цифровую копию собирают из запечатанной капсулы, поэтому до запечатывания
    // раздел закрыт. Уже созданную копию не прячем, даже если статус другой.
    // Пока статус не приехал, не блокируем — иначе пункт моргает замком
    const capsuleStatus = userData?.user?.capsule_status;
    const copy = userData?.user?.digital_copy;
    const hasCopy = !!copy?.avatar_ready || !!copy?.voice_ready;
    const avatarLocked = !!capsuleStatus && !isCapsuleSealed(capsuleStatus) && !hasCopy;




    useEffect(()=>{
        if (!isAvatarHint){
            return;
        }
        const timer = setTimeout(()=>setIsAvatarHint(false), 3000);
        return ()=>clearTimeout(timer);
    },[isAvatarHint])

    const navigateHandler = (route) =>{
        navigate(route);
        setIsMobileNav(false);
    }

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <Logo isCabinet={true}/>
                <div
                    className={`${Styles.mobileBtn} ${isMobileNav ? Styles.mobileBtnActive : ""}`}
                    onClick={() => setIsMobileNav(!isMobileNav)}
                >
                    <span />
                    <span />
                    <span />
                </div>
                <div className={`${Styles.posWrap} ${isMobileNav ? Styles.posWrapActive : ""}`}>
                    <div className={`${Styles.navWrap}`}>
                        <div className={`${Styles.navItem}`}>
                            <div className={`${Styles.navItemContent}`} onClick={()=>{navigateHandler('/cabinet')}}>
                                <div className={`${Styles.navItemContentIcon}`}>
                                    <img src={homeIcon} alt={t('Главная')}/>
                                </div>
                                <div className={`${Styles.navItemContentText}`}>{t('Главная')}</div>
                            </div>
                        </div>
                        {/* Pre-Sale убран из меню: страница живёт по прямой ссылке
                            /cabinet/pre-sale, если понадобится — вернуть пункт сюда */}
                        <div className={`${Styles.navItem}`}>
                            <div className={`${Styles.navItemContent}`} onClick={()=>{navigateHandler('/cabinet/capsule')}}>
                                <div className={`${Styles.navItemContentIcon}`}>
                                    <img src={capsuleIcon} alt={t('Моя капсула')}/>
                                </div>
                                <div className={`${Styles.navItemContentText}`}>{t('Моя капсула')}</div>
                            </div>
                        </div>
                        <div className={`${Styles.navItem} ${avatarLocked ? Styles.navItemDsb : ''} ${Styles.navItemHint}`}>
                            <div
                                className={`${Styles.navItemContent}`}
                                onClick={()=>{
                                    if (avatarLocked){
                                        setIsAvatarHint(true);
                                        return;
                                    }
                                    navigateHandler('/cabinet/avatar');
                                }}
                            >
                                <div className={`${Styles.navItemContentIcon}`}>
                                    <img src={avatarIcon} alt={t('Цифровая копия')}/>
                                </div>
                                <div className={`${Styles.navItemContentText}`}>{t('Цифровая копия')}</div>
                            </div>
                            {/* на тач-устройствах наведения нет, поэтому подсказку
                                дополнительно показываем по тапу */}
                            {avatarLocked ? (
                                <div className={`${Styles.hintBubble} ${isAvatarHint ? Styles.hintBubbleShown : ''}`}>
                                    {t('Запечатайте капсулу перед созданием аватара')}
                                </div>
                            ) : null}
                        </div>
                        {/*<div className={`${Styles.navItem}`}>*/}
                        {/*    <div className={`${Styles.navItemContent}`}>*/}
                        {/*        <div className={`${Styles.navItemContentIcon}`}>*/}
                        {/*            <img src={fmeIcon} alt={t('Future Meta Earth')}/>*/}
                        {/*        </div>*/}
                        {/*        <div className={`${Styles.navItemContentText}`}>{t('Future Meta Earth')}</div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className={`${Styles.navItem}`}>
                            <div className={`${Styles.navItemContent}`} onClick={()=>{navigateHandler('/cabinet/apostol')}}>
                                <div className={`${Styles.navItemContentIcon}`}>
                                    <img src={apostolIcon} alt={t('Программа "Апостол"')}/>
                                </div>
                                <div className={`${Styles.navItemContentText}`}>{t('Программа "Апостол"')}</div>
                            </div>
                        </div>
                    </div>
                    <div className={`${Styles.otherWrap}`}>
                        <div className={`${Styles.settingsWrap}`}>
                            <div className={`${Styles.settings}`}>
                                <div className={`${Styles.settingsContent}`} onClick={()=>{navigateHandler('/cabinet/settings')}}>
                                    <div className={`${Styles.settingsContentIcon}`}>
                                        <img src={settingsIcon} alt={t('Настройки')}/>
                                    </div>
                                    <div className={`${Styles.settingsContentText}`}>{t('Настройки')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={`${Styles.langWrap}`}>
                            <LangSwitcher isCabinet={true}/>
                        </div>
                        <div className={`${Styles.logOutWrap}`}>
                            <div
                                className={`${Styles.logOutBtn}`}
                                onClick={()=>{
                                    if (!logoutStatusStarted){
                                        dispatch(logout());
                                    }
                                }}
                            >
                                <div className={`${Styles.logOutBtnText}`}>
                                    {t('Выйти')}
                                </div>
                                <div className={`${Styles.logOutBtnIcon}`}>
                                    <img src={logOutIcon} alt={t('Выйти')}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetHeader;